/* ==========================================================
   ORIENT PRICE CENTER V2
========================================================== */

document.addEventListener("DOMContentLoaded", function () {

    const tableBody = document.getElementById("opcTableBody");

    if (!tableBody) return;

    const rows = Array.from(tableBody.querySelectorAll(".opc-row"));

    const searchInput = document.getElementById("opcSearch");
    const brandFilter = document.getElementById("opcBrandFilter");
    const sortSelect = document.getElementById("opcSort");
    const counter = document.getElementById("opcResultCount");
    const empty = document.getElementById("opcEmptyState");

    let debounce;

    /* ======================================================]
       COUNTER
    ====================================================== */

    function updateCounter(total){

        if(!counter) return;

        counter.innerHTML = total + " Produk";

    }

    /* ======================================================
       EMPTY STATE
    ====================================================== */

    function updateEmpty(total){

        if(!empty) return;

        empty.style.display = total === 0 ? "flex" : "none";

    }

    /* ======================================================
       FILTER
    ====================================================== */

    function filterRows(){

        const keyword =
            searchInput
                ? searchInput.value.toLowerCase().trim()
                : "";

        const brand =
            brandFilter
                ? brandFilter.value.toLowerCase()
                : "";

        let visible = 0;

        rows.forEach(function(row){

            const search =
                (row.dataset.search || "").toLowerCase();

            const rowBrand =
                (row.dataset.brand || "").toLowerCase();

            const matchKeyword =
                keyword === "" ||
                search.includes(keyword);

            const matchBrand =
                brand === "" ||
                rowBrand === brand;

            if(matchKeyword && matchBrand){

                row.style.display = "";

                visible++;

            }else{

                row.style.display = "none";

            }

        });

        updateCounter(visible);

        updateEmpty(visible);

    }
        /* ======================================================
       SORT
    ====================================================== */

    function sortRows(){

        if(!sortSelect) return;

        const sort = sortSelect.value;

        rows.sort(function(a,b){

            const priceA = Number(a.dataset.price || 0);
            const priceB = Number(b.dataset.price || 0);

            const titleA = (a.dataset.title || "").toLowerCase();
            const titleB = (b.dataset.title || "").toLowerCase();

            switch(sort){

                case "price-asc":
                    return priceA - priceB;

                case "price-desc":
                    return priceB - priceA;

                case "name":
                    return titleA.localeCompare(titleB);

                default:
                    return 0;

            }

        });

        rows.forEach(function(row){

            tableBody.appendChild(row);

        });

    }

    /* ======================================================
       LOADING EFFECT
    ====================================================== */

    function loading(){

        const wrapper = document.querySelector(".opc-table-wrapper");

        if(!wrapper) return;

        wrapper.classList.add("opc-loading");

        clearTimeout(wrapper.loadingTimer);

        wrapper.loadingTimer = setTimeout(function(){

            wrapper.classList.remove("opc-loading");

        },150);

    }

    /* ======================================================
       REFRESH TABLE
    ====================================================== */

    function refresh(){

        loading();

        sortRows();

        filterRows();

    }

    /* ======================================================
       EVENTS
    ====================================================== */

    if(searchInput){

        searchInput.addEventListener("input",function(){

            clearTimeout(debounce);

            debounce = setTimeout(function(){

                refresh();

            },200);

        });

    }

    if(brandFilter){

        brandFilter.addEventListener("change",refresh);

    }

    if(sortSelect){

        sortSelect.addEventListener("change",refresh);

    }
        /* ======================================================
       RESET FILTER
    ====================================================== */

    function resetFilters(){

        if(searchInput){

            searchInput.value = "";

        }

        if(brandFilter){

            brandFilter.selectedIndex = 0;

        }

        if(sortSelect){

            sortSelect.selectedIndex = 0;

        }

        refresh();

    }

    /* ======================================================
       PUBLIC FUNCTION
    ====================================================== */

    window.resetOrientPriceCenter = resetFilters;

    /* ======================================================
       INITIAL LOAD
    ====================================================== */

    refresh();
/* ======================================================
   PRODUCT MODAL
====================================================== */

const modal = document.getElementById("opcModal");

const modalImage = document.getElementById("opcModalImage");
const modalTitle = document.getElementById("opcModalTitle");
const modalPrice = document.getElementById("opcModalPrice");

const modalBrand = document.getElementById("opcBrand");
const modalType = document.getElementById("opcType");
const modalPower = document.getElementById("opcPower");

const modalBrochure = document.getElementById("opcBrochure");
const modalWhatsapp = document.getElementById("opcWhatsapp");

const modalClose = document.querySelector(".opc-modal-close");
const modalOverlay = document.querySelector(".opc-modal-overlay");


document.querySelectorAll(".opc-detail").forEach(function(button){

    button.addEventListener("click",function(e){

        e.preventDefault();

        modalTitle.textContent = this.dataset.title || "-";

        modalPrice.textContent = this.dataset.price || "-";

        modalBrand.textContent = this.dataset.brand || "-";

        /*modalType.textContent = this.dataset.type || "-";

        modalPower.textContent = this.dataset.power || "-";*/
const typeRow = modalType.closest("tr");
const powerRow = modalPower.closest("tr");

if(this.dataset.type){

    modalType.textContent = this.dataset.type;

    typeRow.style.display = "";

}else{

    typeRow.style.display = "none";

}

if(this.dataset.power){

    modalPower.textContent = this.dataset.power;

    powerRow.style.display = "";

}else{

    powerRow.style.display = "none";

}

        modalImage.src = this.dataset.image || "";

        modalImage.alt = this.dataset.title || "";

        modalBrochure.href = this.dataset.brochure || "#";

        modalWhatsapp.href =
            "https://wa.me/6281291266955?text=" +
            encodeURIComponent(
                "Halo, saya ingin bertanya mengenai " +
                this.dataset.title
            );

        modal.classList.add("active");

        document.body.style.overflow = "hidden";

    });

});


function closeModal(){

    modal.classList.remove("active");

    document.body.style.overflow = "";

}


modalClose.addEventListener("click",closeModal);

modalOverlay.addEventListener("click",closeModal);

document.addEventListener("keydown",function(e){

    if(e.key==="Escape"){

        closeModal();

    }

});
});
